<template>
  <div></div>
</template>

<script>
export default {
  name: 'DeleteWarranty',

  props: {
    popupDeleteWarranty: {
      type: Boolean,
      default: false,
    },
    warrantyId: Number,
    number: String,
    customer: String
  },

  watch: {
    popupDeleteWarranty(newVal) {
      if(newVal == true){
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: "حذف گارانتی",
            text: `گارانتی با کد ${this.number} متعلق به ${this.customer} حذف شود؟`,
            acceptText: "حذف",
            cancelText: "انصراف",
            accept: this.deleteWarranty,
            cancel: this.cancelDelete,
        })
      }
    },
  },

  methods: {
    cancelDelete(){
      this.$emit('updatePopupDeleteWarranty', false)
    },

    deleteWarranty(){
      this.$vs.loading()
      this.$emit('updatePopupDeleteWarranty', false)
      this.$store.dispatch('deleteWarranty', this.warrantyId)
      .then(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: '',
          text: 'گارانتی با موفقیت حذف شد.',
          iconPack: 'feather',
          icon: 'icon-check-square',
          color: 'success'
        })
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
        title: '',
        text: 'خطا در اتصال به اینترنت',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
        })
      })
    },
  }
}
</script>
